const parser = new DOMParser();

export const decodeEncodedString = (encodedString: string) => {
  return parser.parseFromString(encodedString, 'text/html').body.textContent ?? '';
};
